import React, { useEffect, useState } from 'react';
import { Text, PropertyGrid, Selector } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import FotaAttrValueOptionsFactory from "../fotaAttrValueOptions/FotaAttrValueOptionsFactory.js";
import { Types } from "../../../../constants/index.js";
function firmwareComponentsSelector(props) {
  const {
    attr,
    onChange,
    data,
    context,
    toItemValue
  } = props;
  const {
    delegate,
    relationship
  } = context;
  const deviceTypeId = Attributes.get('deviceTypeId', Types.firmwareApplication, data);
  const componentTypes = Attributes.get('deviceType$firmwareComponentTypes', Types.firmwareApplication, data);
  const value = attr.get(data);
  const [options, setOptions] = useState({});
  useEffect(() => {
    let valid = true;
    const execute = async () => {
      const limit = 1000,
        allOptions = {
          items: []
        };
      let offset = 0,
        total,
        hasMore;
      do {
        // eslint-disable-next-line no-await-in-loop
        const page = await FotaAttrValueOptionsFactory.create(attr?.source?.targetType, {
          attr,
          delegate,
          relationship,
          limit,
          offset
        });
        total = page.total;
        allOptions.total = page.total;
        allOptions.items = [...allOptions.items, ...page.items];
        offset += limit;
        hasMore = offset < total;
      } while (hasMore && valid);
      if (valid) {
        setOptions(allOptions);
      }
    };
    execute();
    return () => {
      valid = false;
    };
  }, [deviceTypeId]);
  useEffect(() => {
    onChange({
      data: {
        attribute: attr
      },
      value: null
    });
  }, [deviceTypeId]);
  const onChangeEntry = ({
    data,
    value: component
  }) => {
    const {
      index
    } = data;
    const newValue = [...(value ?? [])];
    newValue[index] = toItemValue(component);
    onChange({
      data: {
        attribute: attr
      },
      value: newValue
    });
  };
  if (!deviceTypeId) {
    return /*#__PURE__*/React.createElement(Text, null, "Please Select a Device Type First");
  }
  const valueExpanded = value?.map(val => options?.items?.find(opt => opt?.id === val?.id));
  return /*#__PURE__*/React.createElement(PropertyGrid, null, componentTypes.map((componentType, index) => {
    return /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      key: componentType?.type,
      label: componentType?.name || componentType?.type
    }, /*#__PURE__*/React.createElement(Selector, {
      nameKey: "name",
      valueKey: "value",
      value: valueExpanded?.[index],
      values: options?.items?.filter(option => option.type === componentType.type && Attributes.get('deviceTypeId', Types.firmwareComponent, option) === deviceTypeId)?.map(i => ({
        name: Attributes.get('name', attr?.source?.targetType, i, {
          getImagineName: true
        }),
        value: i
      })),
      onChange: onChangeEntry,
      eventData: {
        index
      }
    }));
  }));
}
const type = 'firmwareComponentsSelector';
export default {
  type,
  editor: firmwareComponentsSelector
};